module.exports = __webpack_public_path__ + "img/sos_room.f509e914.svg";